import { useState } from "react";

const getOpacity = (minutes) => {
  if (minutes === 0) return 0.15;
  if (minutes < 30) return 0.4;
  if (minutes < 90) return 0.7;
  return 1;
};

const formatDate = (date) => {
  return new Date(date).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
  });
};

const HeatmapCard = ({ data, score, onDaysChange }) => {
  const [selectedDays, setSelectedDays] = useState(30);

  const handleChange = (days) => {
    setSelectedDays(days);
    onDaysChange(days); // trigger parent fetch
  };

  return (
    <div className="heatmap-card">

      {/* Header */}
      <div className="heatmap-header">
        <div>
          <h3>Consistency</h3>
          <p className="heatmap-subtext">Last {selectedDays} days</p>
        </div>

        <div className="heatmap-right">
          <span className="score">{score}%</span>

          <select
            value={selectedDays}
            onChange={(e) => handleChange(Number(e.target.value))}
            className="heatmap-dropdown"
          >
            <option value={7}>7d</option>
            <option value={30}>30d</option>
            <option value={90}>90d</option>
          </select>
        </div>
      </div>

      {/* Heatmap Grid */}
      <div className="heatmap-grid">
        {data.map((day, index) => (
          <div
            key={index}
            className="heatmap-cell"
            style={{
              backgroundColor: `rgba(34,197,94, ${getOpacity(day.minutes)*1.5})`,
            }}
            title={`${formatDate(day.date)} • ${day.minutes} mins`}
          />
        ))}
      </div>

    </div>
  );
};

export default HeatmapCard;